"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_IMAGE_SIZE_IN_BYTES = void 0;
var MAX_IMAGE_SIZE_IN_BYTES = exports.MAX_IMAGE_SIZE_IN_BYTES = 5242880;